import { useTranslation } from 'react-i18next'

import { CalendarBlank } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { DesktopDatePicker } from '@mui/x-date-pickers'
import { InputWithLabel } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const DatePickers = ({ value, onChangeStartDate, onChangeEndDate }) => {
  const theme = useTheme()
  const CalendarIcon = () => <CalendarBlank size={16} weight="light" color={theme.colors.text.default} />
  const { t } = useTranslation()

  return (
    <Styles.DatesContainer>
      <DesktopDatePicker
        maxDate={value?.endDate}
        inputFormat="DD/MM/YYYY"
        value={value?.startDate || null}
        onChange={onChangeStartDate}
        components={{
          OpenPickerIcon: CalendarIcon,
        }}
        renderInput={({ inputRef, inputProps, InputProps }) => {
          return (
            <Styles.InputContainer>
              <div>
                <InputWithLabel
                  fullWidth
                  value={inputProps.value}
                  onChange={inputProps.onChange}
                  placeholder={t('Inicio (DD/MM/AAAA)')}
                  inputRef={inputRef}
                />
              </div>
              <div>{InputProps.endAdornment}</div>
            </Styles.InputContainer>
          )
        }}
      />
      <DesktopDatePicker
        minDate={value?.startDate}
        inputFormat="DD/MM/YYYY"
        value={value?.endDate || null}
        onChange={onChangeEndDate}
        components={{
          OpenPickerIcon: CalendarIcon,
        }}
        renderInput={({ inputRef, inputProps, InputProps }) => {
          return (
            <Styles.InputContainer>
              <div>
                <InputWithLabel
                  fullWidth
                  value={inputProps.value}
                  onChange={inputProps.onChange}
                  placeholder={t('Fin (DD/MM/AAAA)')}
                  inputRef={inputRef}
                />
              </div>
              <div>{InputProps.endAdornment}</div>
            </Styles.InputContainer>
          )
        }}
      />
    </Styles.DatesContainer>
  )
}

export default DatePickers
